import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';
import * as actions from 'redux/actions/settingActions';

const toBool = (value) => value === true || value === 1 || value === '1';

const Notifications = (props) => {
  const [values, setValues] = useState({
    notification_email_enabled: toBool(props.item?.notification_email_enabled),
    holiday_email_enabled: toBool(props.item?.holiday_email_enabled),
    alert_email_enabled: toBool(props.item?.alert_email_enabled),
  });

  useEffect(() => {
    setValues({
      notification_email_enabled: toBool(props.item?.notification_email_enabled),
      holiday_email_enabled: toBool(props.item?.holiday_email_enabled),
      alert_email_enabled: toBool(props.item?.alert_email_enabled),
    });
  }, [props.item]);

  const buildPayload = (nextValues) => {
    const notificationEnabled = nextValues.notification_email_enabled
      || nextValues.holiday_email_enabled
      || nextValues.alert_email_enabled;
    return {
      id: props.user_id,
      tax_id: props.item?.id,
      option_tax: props.item?.option_tax ?? 0,
      stock_tax: props.item?.stock_tax ?? 0,
      notification_email_enabled: notificationEnabled,
      holiday_email_enabled: notificationEnabled ? nextValues.holiday_email_enabled : false,
      alert_email_enabled: notificationEnabled ? nextValues.alert_email_enabled : false,
    };
  };

  const handleChange = (event) => {
    const { name, checked } = event.target;
    let next = { ...values, [name]: checked };

    if ((name === 'holiday_email_enabled' || name === 'alert_email_enabled') && checked) {
      next = {
        ...next,
        notification_email_enabled: true,
        [name]: true,
      };
    } else if (name === 'notification_email_enabled' && !checked) {
      next = {
        ...next,
        notification_email_enabled: false,
        holiday_email_enabled: false,
        alert_email_enabled: false,
      };
    }

    setValues(next);
    props.updateItem(buildPayload(next), props.token);
  };

  const handleSave = () => {
    props.updateItem(buildPayload(values), props.token);
  };

  return (
    <div className="settings-panel">
      <h3 className="settings-panel-title">
        <Translate value="notifications" />
      </h3>
      <p className="settings-panel-subtitle">
        <Translate value="manage_notifications" />
      </p>
      <div className="settings-panel-content">
        <div className="settings-check-group">
          <div className="settings-check-column">
            <h6>
              <Translate value="notifications" />
            </h6>
            <label htmlFor="notif-email">
              <input
                type="checkbox"
                id="notif-email"
                name="notification_email_enabled"
                checked={values.notification_email_enabled}
                onChange={handleChange}
              />
              <Translate value="settings_notification_email" />
            </label>
            <label htmlFor="holiday-email">
              <input
                type="checkbox"
                id="holiday-email"
                name="holiday_email_enabled"
                checked={values.holiday_email_enabled}
                onChange={handleChange}
              />
              <Translate value="settings_holiday_email" />
            </label>
            <label htmlFor="alert-email">
              <input
                type="checkbox"
                id="alert-email"
                name="alert_email_enabled"
                checked={values.alert_email_enabled}
                onChange={handleChange}
              />
              <Translate value="settings_alert_email" />
            </label>
            <p className="settings-inline-hint">
              <Translate value="settings_holiday_email_hint" />
            </p>
            {props.userEmail && (
              <p className="settings-inline-hint settings-email-target">
                <Translate value="settings_holiday_email_target" email={props.userEmail} />
              </p>
            )}
          </div>
        </div>
      </div>
      <div className="settings-panel-actions">
        <button type="button" className="btn btn-primary" onClick={handleSave}>
          <Translate value="save" />
        </button>
      </div>
    </div>
  );
};

Notifications.propTypes = {
  className: PropTypes.string,
};

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    userEmail: reducer.session.auth.email,
    token: reducer.session.auth.token,
    item: reducer.setting.item,
  };
}

const mapDispatchToProps = (dispatch) => ({
  updateItem: (params, token) =>
    dispatch(actions.updateItem({ params, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
